module.exports = __webpack_public_path__ + "img/hybrid_work.5c99116b.jpeg";